import { useState, useEffect } from 'react';
import NotificationService from '../services/NotificationService';
import MobileService from '../services/MobileService';

export const useNotifications = () => {
  const [isSupported, setIsSupported] = useState(false);
  const [permissions, setPermissions] = useState(null);
  const [pendingNotifications, setPendingNotifications] = useState([]);

  useEffect(() => {
    const checkSupport = async () => {
      const supported = NotificationService.isSupported();
      setIsSupported(supported);
      
      if (supported) {
        // Get pending notifications
        const pending = await NotificationService.getPendingNotifications();
        setPendingNotifications(pending);
      }
    };

    checkSupport();
  }, []);

  const scheduleEventReminder = async (event) => {
    try {
      await NotificationService.scheduleEventReminder(event);
      
      // Update pending notifications
      const pending = await NotificationService.getPendingNotifications();
      setPendingNotifications(pending);
      
      return true;
    } catch (error) {
      console.error('Failed to schedule event reminder:', error);
      return false;
    }
  };

  const scheduleSankalpaReminder = async (time = '06:00') => {
    try {
      await NotificationService.scheduleDailySankalpReminder(time);
      
      const pending = await NotificationService.getPendingNotifications();
      setPendingNotifications(pending);
      
      return true;
    } catch (error) {
      console.error('Failed to schedule Sankalpa reminder:', error);
      return false;
    }
  };

  const cancelEventReminder = async (eventId) => {
    try {
      await NotificationService.cancelEventReminder(eventId);
      
      const pending = await NotificationService.getPendingNotifications();
      setPendingNotifications(pending);
      
      return true;
    } catch (error) {
      console.error('Failed to cancel event reminder:', error);
      return false;
    }
  };

  const sendTestNotification = async () => {
    try {
      await NotificationService.sendTestNotification();
      return true;
    } catch (error) {
      console.error('Failed to send test notification:', error);
      return false;
    }
  };

  const clearAllNotifications = async () => {
    try {
      await NotificationService.clearAllNotifications();
      setPendingNotifications([]);
      return true;
    } catch (error) {
      console.error('Failed to clear notifications:', error);
      return false;
    }
  };

  return {
    isSupported,
    permissions,
    pendingNotifications,
    scheduleEventReminder,
    scheduleSankalpaReminder,
    cancelEventReminder,
    sendTestNotification,
    clearAllNotifications
  };
};

export default useNotifications;